var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNps3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 114,
    viewBox: "0 0 164 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.999999V83.8541C0 84.4064 0.447716 84.8541 1 84.8541H10.6778C11.2301 84.8541 11.6778 84.4064 11.6778 83.8541V47.3567H58.781V83.8541C58.781 84.4064 59.2287 84.8541 59.781 84.8541H69.4589C70.0111 84.8541 70.4589 84.4064 70.4589 83.8541V11.5234V10.0209H119.785V15.7826V33.7974H131.487V5.7617C131.487 2.5796 128.826 0 125.544 0H63.9757H59.781C59.2287 0 58.781 0.447715 58.781 1V37.4974H11.6778V1C11.6778 0.447715 11.2301 0 10.6778 0H1C0.447715 0 0 0.447714 0 0.999999Z",
    fill: "url(#paint0_linear_3457_3849)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.785 79.1812C119.785 82.3143 122.404 84.8541 125.636 84.8541C128.867 84.8541 131.487 82.3143 131.487 79.1812V46.25L119.785 47.3567V79.1812Z",
    fill: "url(#paint1_linear_3457_3849)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.394 107.533L107.406 107.539L107.418 107.545C113.973 110.859 121.345 112.5 129.502 112.5C136.513 112.5 142.892 111.245 148.612 108.706L148.622 108.701L148.631 108.697C153.686 106.367 157.823 103.108 161.011 98.9162C162.266 97.266 161.701 95.0072 160.061 93.98L155.25 90.9667C153.689 89.9894 151.728 90.4141 150.608 91.7178C148.217 94.5004 145.369 96.612 142.05 98.0655C138.176 99.762 133.949 100.618 129.349 100.618C123.857 100.618 118.951 99.4905 114.6 97.2641C110.248 94.9433 106.833 91.7453 104.328 87.6589C101.843 83.6048 100.574 78.8093 100.574 73.2167C100.574 67.624 101.843 62.8286 104.328 58.7745C106.832 54.6898 110.243 51.5421 114.59 49.3158L114.6 49.3103L114.611 49.3046C118.96 46.9876 123.862 45.8152 129.349 45.8152C133.949 45.8152 138.176 46.6714 142.05 48.3678C145.362 49.8183 148.208 51.9604 150.6 54.8116L151.749 53.8476L150.6 54.8116C151.714 56.1403 153.694 56.5819 155.269 55.5957L160.077 52.5847C161.706 51.5639 162.277 49.3244 161.044 47.6732C157.85 43.394 153.695 40.1256 148.612 37.8688C142.892 35.3293 136.513 34.0742 129.502 34.0742C121.345 34.0742 113.973 35.7149 107.418 39.029L107.418 39.029L107.41 39.0335C100.965 42.3454 95.8667 46.9417 92.149 52.8181C88.4127 58.7238 86.5649 65.5407 86.5649 73.2167C86.5649 80.803 88.4146 87.6144 92.143 93.6058L92.143 93.6059L92.149 93.6153C95.8642 99.4877 100.958 104.128 107.394 107.533Z",
    stroke: "url(#paint2_linear_3457_3849)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3457_3849",
    x1: 86.0722,
    y1: -5.30339,
    x2: 130.882,
    y2: 80.6753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3457_3849",
    x1: 86.0722,
    y1: -5.30339,
    x2: 130.882,
    y2: 80.6753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3457_3849",
    x1: 135.809,
    y1: 30.8601,
    x2: 183.623,
    y2: 88.1111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNps3);
export default __webpack_public_path__ + "static/media/nps3.5eb37bf3d28292a00916d6ba872a4031.svg";
export { ForwardRef as ReactComponent };